<template>
  <v-container fluid class="mt-16 px-6">
    <div>
      <v-card flat>
        <v-card-title class="d-flex">
          <h2>Supplier Purchase Orders</h2>
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            outlined
            @click="refreshData"
            class="mr-2"
            :loading="refreshing"
          >
            <v-icon left>mdi-refresh</v-icon>
            Refresh
          </v-btn>
        </v-card-title>

        <v-card-text>
          <!-- Purchase Order Table -->
          <supplier-purchase-order-table
            ref="purchaseOrderTable"
            @notification="handleNotification"
          />
        </v-card-text>
      </v-card>
    </div>

    <!-- Notification Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
      right
    >
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import SupplierPurchaseOrderTable from "../components/SupplierPurchaseOrder/SupplierPurchaseOrderTable.vue";

export default {
  name: "SupplierPurchaseOrder",

  components: {
    SupplierPurchaseOrderTable,
  },

  data() {
    return {
      refreshing: false,
      snackbar: {
        show: false,
        message: "",
        color: "success",
        timeout: 3000,
      },
    };
  },

  computed: {
    ...mapGetters({
      user: "auth/user",
      default_server_url: "auth/default_server_url",
    }),
  },

  methods: {
    handleNotification(message, type) {
      const colorMap = {
        success: "success",
        error: "error",
        info: "info",
        warning: "warning",
      };

      this.snackbar = {
        show: true,
        message: message,
        color: colorMap[type] || "info",
        timeout: type === "error" ? 5000 : 3000,
      };
    },

    async refreshData() {
      this.refreshing = true;
      try {
        if (this.$refs.purchaseOrderTable) {
          await this.$refs.purchaseOrderTable.refreshTable();
        }
      } catch (error) {
        this.handleNotification("Failed to refresh data", "error");
      } finally {
        this.refreshing = false;
      }
    },
  },

  mounted() {
    // Any initialization logic can go here
  },
};
</script>

<style scoped></style>
